/** TanStack Query hooks for plugin catalogue (SPA_TANSTACK_QUERY). */

import { useQuery } from "@tanstack/react-query";
import { api, type PaginatedResponse } from "@/services/api";
import type { Plugin } from "@/types";

export function usePlugins() {
  return useQuery<PaginatedResponse<Plugin>>({
    queryKey: ["plugins"],
    queryFn: () => api.get("/reporting/plugins"),
  });
}

export function usePlugin(pluginId: string) {
  return useQuery<Plugin>({
    queryKey: ["plugin", pluginId],
    queryFn: () => api.get(`/reporting/plugins/${pluginId}`),
    enabled: !!pluginId,
  });
}
